import { render } from "./manage-programs-success.vue?vue&type=template&id=c665582c&lang=pug"
import script from "./manage-programs-success.vue?vue&type=script&lang=js"
export * from "./manage-programs-success.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__